// extracted by mini-css-extract-plugin
export default {"text":"Text_text__-zVCm","centerText":"Text_centerText__uD6KH"};